var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2486 0.333313C21.2036 0.333313 23.8519 3.10998 23.8519 7.23998V16.7728C23.8519 20.8911 21.2036 23.6666 17.2486 23.6666H7.13356C3.17856 23.6666 0.518555 20.8911 0.518555 16.7728V7.23998C0.518555 3.10998 3.17856 0.333313 7.13356 0.333313H17.2486ZM12.1736 10.2278C11.6136 10.2278 11.1586 10.6933 11.1586 11.2545V16.4111C11.1586 16.9711 11.6136 17.4261 12.1736 17.4261C12.7452 17.4261 13.2002 16.9711 13.2002 16.4111V11.2545C13.2002 10.6933 12.7452 10.2278 12.1736 10.2278ZM12.1969 6.52948C11.6252 6.52948 11.1702 6.98448 11.1702 7.55615C11.1702 8.11498 11.6252 8.57115 12.1736 8.57115C12.7569 8.57115 13.2119 8.11498 13.2119 7.55615C13.2119 6.98448 12.7569 6.52948 12.1969 6.52948Z",
    fill: "#137AD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInfo);
export default __webpack_public_path__ + "static/media/toastInfo.98867e9fc1d95d8807f6a4d57d1774bb.svg";
export { ForwardRef as ReactComponent };